import { Component, ViewEncapsulation } from "@angular/core";
import { Store } from "@ngxs/store";

import { Actions } from "./electrical-products-filter.actions";

@Component({
  selector: "electrical-products-filter",
  templateUrl: "./electrical-products-filter.component.html",
  styleUrls: ["./electrical-products-filter.component.scss"],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class ElectricalProductsFilterComponent {
  get selectedFilter() {
    return this._selectedFilter;
  }
  _selectedFilter = "*";
  set selectedFilter(filter: string) {
    this._selectedFilter = filter;
  }

  constructor(private store: Store) {}
  onChange() {
    this.store.dispatch(new Actions.Completed(this.selectedFilter));
  }
}
